<template>
  <v-navigation-drawer
    :value="sideBar"
    fixed
    @input="setSideBar($event)"
    style="box-shadow: 2px 2px 15px #cecece; height: 100% !important"
    :style="
      !$vuetify.breakpoint.smAndDown ? 'border-radius: 0px 15px 15px 0px' : ''
    "
    color="#ffffff"
    :width="widthSidebar"
    disable-resize-watcher
    temporary
    overlay-color="transparent"
  >
    <template v-slot:prepend>
      <!--      close menu-->
      <v-btn icon @click="setSideBar(false)" class="sidebar--close">
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-list-item two-line class="flex justify-center" style="width: 100%">
        <v-img
          class="mb-8 sidebar--logo"
          src="@/assets/img/logo-gob.svg"
          style="max-width: 80% !important;"
        ></v-img>
      </v-list-item>

      <v-text-field
        dense
        rounded
        filled
        placeholder="Buscar en el menú"
        prepend-inner-icon="mdi-magnify"
        class="mx-5"
        v-model="search"
        @input="searchMenuOptions"
        clearable
      />
    </template>

    <v-list nav dense>
      <span v-for="(item, i) in menuLocal" :key="i">
        <!-- Tiene hijos -->
        <v-list-group
          :value="isGroupOpen(item)"
          :data-menu-active="isCurrentMenuItem(item)"
          active-class="selectedBgPurple--text"
          @input="setGroupOpen(item, $event)"
          v-if="item.dependencias && item.dependencias.length"
        >
          <template #prependIcon>
            <v-icon color="#313945">{{ item.icono }}</v-icon>
          </template>
          <template v-slot:activator>
            <v-list-item-title
              style="
                color: #313945;
                font-size: 0.8125rem;
                font-weight: 500 !important;
                line-height: 1rem;
              "
              >{{ item.titulo }}</v-list-item-title
            >
          </template>

          <span v-for="(child, j) in item.dependencias" :key="j">
            <v-list-group
              :value="isGroupOpen(child)"
              :data-menu-active="isCurrentMenuItem(child)"
              no-action
              sub-group
              active-class="selectedBgPurple--text"
              @input="setGroupOpen(child, $event)"
              v-if="child.dependencias && child.dependencias.length"
            >
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title
                    style="
                      color: #313945;
                      font-size: 0.8125rem;
                      font-weight: 500 !important;
                    "
                    >{{ child.titulo }}</v-list-item-title
                  >
                </v-list-item-content>
              </template>

              <v-list-item
                v-for="(sub_child, k) in child.dependencias"
                :key="k"
                :input-value="isCurrentMenuItem(sub_child)"
                :data-menu-active="isCurrentMenuItem(sub_child)"
                active-class="selectedBgPurple--text"
                @click="
                  redirect(
                    item?.base_url,
                    `${sub_child?.base_url + sub_child.ruta || ''}`
                  )
                "
              >
                <v-list-item-title
                  style="
                    color: #313945;
                    font-size: 0.8125rem;
                    font-weight: 500 !important;
                  "
                  >{{ sub_child.titulo }}</v-list-item-title
                >
                <v-list-item-icon>
                  <v-icon color="#313945">{{ sub_child.icono }}</v-icon>
                </v-list-item-icon>
              </v-list-item>
            </v-list-group>

            <v-list-item
              v-else
              :input-value="isCurrentMenuItem(child)"
              :data-menu-active="isCurrentMenuItem(child)"
              active-class=" selectedBgPurple--text"
              @click="
                redirect(
                  child?.base_url,
                  `${child?.base_url + child.ruta || ''}`
                )
              "
            >
              <v-list-item-icon>
                <v-icon color="#313945">{{ child.icono }}</v-icon>
              </v-list-item-icon>

              <v-list-item-title
                style="
                  color: #313945;
                  font-size: 0.8125rem;
                  font-weight: 500 !important;
                "
                >{{ child.titulo }}</v-list-item-title
              >
            </v-list-item>
          </span>
        </v-list-group>

        <!-- No tiene hijos -->
        <v-list-item
          v-else
          :input-value="isCurrentMenuItem(item)"
          :data-menu-active="isCurrentMenuItem(item)"
          @click="
            redirect(item?.base_url, `${item?.base_url + item?.ruta || ''}`)
          "
          active-class=" selectedBgPurple--text"
        >
          <v-list-item-icon>
            <v-icon color="#313945">{{ item.icono }}</v-icon>
          </v-list-item-icon>

          <v-list-item-title
            style="
              color: #313945;
              font-size: 0.8125rem;
              font-weight: 500 !important;
            "
            >{{ item.titulo }}</v-list-item-title
          >
        </v-list-item>
      </span>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import jwtDecode from "jwt-decode";

export default {
  name: "AppAsideBar",
  props: {
    menu: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      search: "",
      menuLocal: [],
      screenWidth: window.innerWidth,
      openGroups: {}
    };
  },

  watch: {
    menu: {
      handler: function (val) {
        this.menuLocal = val;
        this.openActiveMenuGroups();
      },
      immediate: true
    },

    "$route.path": {
      handler: function () {
        this.openActiveMenuGroups();
      },
      immediate: true
    },

    sideBar: {
      handler: function (isOpen) {
        if (isOpen) {
          this.scrollToCurrentMenuItem();
        }
      }
    },

    screenWidth: {
      handler: function () {
        this.setSideBar(false);
      }
    }
  },

  updated() {
    window.addEventListener("resize", () => {
      this.screenWidth = window.innerWidth;
    });
  },

  methods: {
    ...mapMutations("utils", ["setSideBar"]),
    redirect(base_url, url) {
      const token = localStorage.getItem("token");
      const sessionUuid = localStorage.getItem("session_uuid");

      if (base_url == window.location.origin) {
        window.location = url;
      } else {
        window.location = `${url}?session=${sessionUuid}`;
      }
      this.setSideBar(false);
    },

    normalizePath(path) {
      if (!path || typeof path !== "string") return "";

      const normalized = path.split(/[?#]/)[0].replace(/\/+$/, "");
      if (!normalized) return "";

      return normalized.startsWith("/") ? normalized : `/${normalized}`;
    },

    belongsToCurrentFrontend(item) {
      return item && item.base_url === window.location.origin;
    },

    matchesCurrentRoute(menuPath, currentPath) {
      if (!menuPath || menuPath === "/") return false;

      return currentPath === menuPath || currentPath.startsWith(`${menuPath}/`);
    },

    findCurrentTrail(nodes, parents = []) {
      const currentPath = this.normalizePath(this.$route && this.$route.path);
      if (!currentPath || currentPath === "/" || currentPath === "/login") {
        return [];
      }

      let bestMatch = [];
      let bestPathLength = -1;

      const visit = (items, ancestors) => {
        (items || []).forEach((item) => {
          const trail = [...ancestors, item];
          const menuPath = this.normalizePath(item.ruta);

          if (
            this.belongsToCurrentFrontend(item) &&
            this.matchesCurrentRoute(menuPath, currentPath) &&
            menuPath.length > bestPathLength
          ) {
            bestMatch = trail;
            bestPathLength = menuPath.length;
          }

          if (Array.isArray(item.dependencias) && item.dependencias.length) {
            visit(item.dependencias, trail);
          }
        });
      };

      visit(nodes, parents);
      return bestMatch;
    },

    menuItemKey(item) {
      return [item.id, item.base_url, item.ruta, item.titulo].join("|");
    },

    isCurrentMenuItem(item) {
      return this.activeMenuItemKey === this.menuItemKey(item);
    },

    isGroupOpen(item) {
      const key = this.menuItemKey(item);
      return this.activeGroupKeys.includes(key) || Boolean(this.openGroups[key]);
    },

    setGroupOpen(item, isOpen) {
      this.$set(this.openGroups, this.menuItemKey(item), isOpen);
    },

    openActiveMenuGroups() {
      this.activeGroupKeys.forEach((key) => {
        this.$set(this.openGroups, key, true);
      });

      if (this.sideBar && !this.search) {
        this.scrollToCurrentMenuItem();
      }
    },

    scrollToCurrentMenuItem() {
      if (!this.sideBar || this.search || !this.activeMenuItemKey) return;

      this.$nextTick(() => {
        const drawerContent = this.$el.querySelector(
          ".v-navigation-drawer__content"
        );
        const activeItem = this.$el.querySelector(
          '[data-menu-active="true"]'
        );

        if (!drawerContent || !activeItem) return;

        const drawerRect = drawerContent.getBoundingClientRect();
        const itemRect = activeItem.getBoundingClientRect();
        const scrollTop = Math.max(
          0,
          drawerContent.scrollTop + itemRect.top - drawerRect.top - 16
        );

        if (typeof drawerContent.scrollTo === "function") {
          drawerContent.scrollTo({ top: scrollTop, behavior: "smooth" });
        } else {
          drawerContent.scrollTop = scrollTop;
        }
      });
    },

    searchMenuOptions() {
      let menusFound = [];

      if (!this.search) {
        this.menuLocal = this.menu;
        return;
      }

      const searchRecursive = (items, base_url = null) => {
        items.forEach((item) => {
          const search = this.quitarTildes(this.search)?.toLowerCase();
          const itemSearch = this.quitarTildes(item.titulo)?.toLowerCase();
          if (itemSearch.includes(search)) {
            if (base_url) {
              item.base_url = base_url;
            }
            menusFound.push(item);
          }

          // Continúa la búsqueda en las dependencias del elemento actual
          if (item.dependencias) {
            searchRecursive(item.dependencias, base_url);
          }
        });
      };

      //inicia busqueda en menu principal
      searchRecursive(this.menu);
      this.menuLocal = menusFound;
    },

    quitarTildes(str) {
      return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    }
  },
  computed: {
    ...mapState("utils", ["sideBar"]),
    activeMenuTrail() {
      return this.findCurrentTrail(this.menu);
    },

    activeMenuItemKey() {
      const activeItem = this.activeMenuTrail[this.activeMenuTrail.length - 1];
      return activeItem ? this.menuItemKey(activeItem) : "";
    },

    activeGroupKeys() {
      return this.activeMenuTrail
        .filter(
          (item) => Array.isArray(item.dependencias) && item.dependencias.length
        )
        .map((item) => this.menuItemKey(item));
    },

    breakpoint() {
      if (this.$vuetify.breakpoint.sm) {
        return !this.sideBar;
      } else if (this.$vuetify.breakpoint.xs) {
        return !this.sideBar;
      } else if (this.$vuetify.breakpoint.md) {
        return true;
      } else if (this.$vuetify.breakpoint.lg) {
        return true;
      } else if (this.$vuetify.breakpoint.xl) {
        return true;
      } else {
        return !this.sideBar;
      }
    },

    widthSidebar() {
      if (this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.sm) {
        return "100%";
      } else if (this.$vuetify.breakpoint.sm) {
        return "75%";
      } else if (this.$vuetify.breakpoint.md) {
        return "65%";
      } else if (this.$vuetify.breakpoint.lg) {
        return "35%";
      } else if (this.$vuetify.breakpoint.xl) {
        return "30%";
      } else {
        return "70%";
      }
    }
  },

  filters: {
    capitalize: function (value) {
      if (!value) return "";
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    }
  },
  mounted() {
    this.setSideBar(false);
  }
};
</script>

<style scoped>
:deep(.v-list-group__items) {
  flex: 1 1 auto;
  /* background-color: #f5f9ff; */
  background-color: #ffff;
  border-radius: 10px;
}

:deep(.mdi-chevron-down::before) {
  content: "\F0140";
  color: #313945;
}

.sidebar--logo {
  width: 100%;
  height: calc(100% - 20px);
  max-width: 250px;
  margin: 0 auto;
}

.sidebar--close {
  float: right;
  right: 10px;
  top: 15px;
}
</style>
